import { Tooltip } from "@2u-landing-pages/components/Tooltip";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Block, BLOCKS, Inline, MARKS } from "@contentful/rich-text-types";
import React from "react";
import { OneTrustLink } from "../templates/Footer/OneTrustLink";

export const renderMark = {
  [MARKS.BOLD]: (text: React.ReactNode | string) => <strong>{text}</strong>,
  [MARKS.ITALIC]: (text: React.ReactNode | string) => <em>{text}</em>,
};

export const renderText = (text: string) => {
  const processedText = [text].reduce((children: React.ReactNode[], textSegment: React.ReactNode, index: number) => {
    if (typeof textSegment === "string" && textSegment.includes("\n")) {
      const segmentParts = textSegment.split("\n");
      segmentParts.forEach((part, i) => {
        children.push(part);
        if (i < segmentParts.length - 1) {
          children.push(<br key={`${index}_br_${i}`} />);
        }
      });
    } else {
      children.push(textSegment);
    }
    return children;
  }, []);

  return processedText;
};

export const renderFooterText = (text: string, phone_number: string = "", isExeced: boolean) => {
  const placeholder_regex = /({{phone_number}}|{{one_trust_privacy_link}})/g;

  return text.split(placeholder_regex).map((segment, index) => {
    switch (segment) {
      case "{{phone_number}}":
        return (
          <a key={index} href={`tel:${phone_number}`}>
            {phone_number}
          </a>
        );
      case "{{one_trust_privacy_link}}":
        return <OneTrustLink>Your Privacy {isExeced ? "Choices" : "Rights"}</OneTrustLink>;
      default:
        return renderText(segment);
    }
  });
};

export const renderEmbeddedEntry = (
  node?: Block | Inline,
  location?: string,
  parentContent?: Inline | Block,
  iconSize?: "sm" | "md"
) => {
  if (node) {
    const tooltip = node?.data?.target?.sys?.contentType?.sys?.id === "tooltip";
    const isInlineContent = node?.data?.target?.sys?.contentType?.sys?.id === "inline_content";

    if (tooltip || (isInlineContent && node.data.target.fields.tooltipPosition)) {
      // body, content, icon_size, position cone from tooltip and will be removed in the future.
      const { body, content, icon_size, position, tooltipPosition } = node.data.target.fields;
      return (
        <Tooltip
          body={content || body}
          icon_size={icon_size || iconSize || "sm"}
          position={tooltipPosition || position}
          location={location}
          parentContent={parentContent}
        />
      );
    } else if (isInlineContent) {
      return (
        <>
          {documentToReactComponents(node.data.target.fields.content, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, children) => <span>{children}</span>,
            },
          })}
        </>
      );
    }

    return null;
  }
  return null;
};

export const findPrivacyPolicyLink = (content: any): string | null => {
  if (!content || !Array.isArray(content)) return null;

  for (const node of content) {
    if (node?.nodeType === "hyperlink") {
      const hasPrivacyPolicyText = node?.content?.some(
        (textNode: any) =>
          textNode?.nodeType === "text" && textNode?.value?.trim()?.toLowerCase()?.includes("privacy policy")
      );

      if (hasPrivacyPolicyText) {
        return node?.data?.uri || null;
      }
    }

    // Recursively search in nested content
    if (node?.content) {
      const found = findPrivacyPolicyLink(node.content);
      if (found) return found;
    }
  }

  return null;
};
